module.exports = __webpack_public_path__ + "static/media/friends.78209e44.png";